import React, { useCallback, useState } from 'react';
import { NumericInput } from '@gafe/common-ui';

import { useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { ContractDetailsWrapper } from '../ContractDetailsWrapper';

export const ContractAmount = (): JSX.Element => {
  const dispatch = useOrderDispatch();
  const [value, setValue] = useState<string | undefined>();
  const handleOnChange = useCallback(
    (value: string | undefined) => {
      setValue(value);
      dispatch({
        type: 'UPDATE_ORDER',
        payload: {
          totalContractAmount: Number(value) > 0 ? Number(value) : undefined,
        },
      });
    },
    [dispatch],
  );

  return (
    <ContractDetailsWrapper title="What is the total contract amount?">
      <NumericInput
        allowNegative={false}
        data-testid="contract-amount"
        decimalScale={2}
        onChange={handleOnChange}
        placeholder="$ -"
        prefix="$"
        value={value ? value : ''}
        width="lg"
      />
    </ContractDetailsWrapper>
  );
};
